import { useNavigate } from "react-router-dom";
import Button from "../../components/reusable/button";
import NotFoundImage from "../../assets/images/404 illustration.svg";
import PerceiveLogo from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";
import PrimaryButton from "src/components/reusable/button/primary-button";

export default function PageNotFound404() {
  const navigate = useNavigate();

  return (
    <div className="bg-white text-gray-800 p-4">
      {/* Logo */}
      <div className=" py-1 px-2 sticky top-0 z-[10] flex flex-col items-center justify-center">
        <Link to="/">
          <img src={PerceiveLogo} alt="PerceiveNow logo" />
        </Link>
      </div>
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-150px)] ">
        {/* Illustration */}
        <div className="">
          {/* Replace below div with your illustration */}
          <img src={NotFoundImage} alt="Page not found illustration" className="w-60 h-auto" />
        </div>

        {/* Text */}
        <h1 className="text-2xl font-semibold mb-4">Page Not Found</h1>
        <p className="text-gray-500 mb-6 text-center">
          The link may be broken or the page may have been removed.
        </p>

        {/* Button */}
        <PrimaryButton
          onClick={() => navigate(-1)}
          // rounded={"full"}
          // classname="px-6 py-2 bg-secondary-500 border-[#442873] text-white font-semibold transition"
          text="Back to Home"
        />
      </div>
    </div>
  );
}
